import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Auth endpoints


export const loginUserManual = async (username, password) => {
    const response = await api.post('/auth/login-manual', { username, password });
    return response.data;
};

export const registerUserManual = async (formData) => {
    const response = await api.post('/auth/register-manual', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};

export const getUserProfile = async (userId) => {
    // Add cache-busting parameters to prevent stale data
    const response = await api.get(`/auth/profile/${userId}`, {
        params: {
            _t: Date.now(),
            _r: Math.random()
        },
        headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
        }
    });
    // Ensure response has both _id and id for compatibility
    const profile = response.data;
    if (profile && profile._id && !profile.id) {
        profile.id = profile._id;
    }
    return profile;
};

export const updateProfile = async (userId, formData) => {
    const response = await api.put(`/auth/update-profile/${userId}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};

// User endpoints
export const getOnlineFemales = async (callerId = null) => {
    const response = await api.get('/users/online-females', {
        params: {
            ...(callerId ? { callerId } : {}),
            _t: Date.now(),
            _r: Math.random()
        },
        headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
        }
    });
    return response.data;
};

export const updateUserStatus = async (userId, isOnline, isBusy) => {
    const response = await api.put(`/users/status/${userId}`, { isOnline, isBusy });
    return response.data;
};

export const getUserBalance = async (userId) => {
    // Add timestamp and random number to prevent caching
    const response = await api.get(`/users/balance/${userId}`, {
        params: {
            _t: Date.now(),
            _r: Math.random()
        },
        headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
        }
    });
    return response.data;
};

export const getUserEarnings = async (userId) => {
    const response = await api.get(`/users/earnings/${userId}`);
    return response.data;
};

export const requestPayout = async (userId, paypalEmail) => {
    const response = await api.post(`/users/request-payout/${userId}`, { paypalEmail });
    return response.data;
};

export const getPayoutStatus = async (userId) => {
    const response = await api.get(`/users/payout-status/${userId}`);
    return response.data;
};

// Payment endpoints
export const purchasePackage = async (userId, packageId, paymentMethod, paymentData = null, googlePlayData = null) => {
    const requestBody = {
        userId,
        packageId,
        paymentMethod,
        paymentData
    };

    // Add Google Play Billing data if provided
    if (googlePlayData) {
        requestBody.purchaseToken = googlePlayData.purchaseToken;
        requestBody.productId = googlePlayData.productId;
        requestBody.orderId = googlePlayData.orderId;
        requestBody.packageName = googlePlayData.packageName;
    }

    const response = await api.post('/payment/purchase-package', requestBody);
    return response.data;
};

export const startCall = async (callerId, receiverId) => {
    const response = await api.post('/payment/start-call', {
        callerId,
        receiverId
    });
    return response.data;
};

export const endCall = async (callId, duration) => {
    const response = await api.post('/payment/end-call', {
        callId,
        duration
    });
    return response.data;
};

export const checkBalance = async (userId, receiverId) => {
    const response = await api.get(`/payment/check-balance/${userId}/${receiverId}`);
    return response.data;
};

// Admin endpoints
export const getPendingUsers = async () => {
    const response = await api.get('/admin/pending-users');
    return response.data;
};

export const approveUser = async (userId, status, pricePerMinute) => {
    const response = await api.put(`/admin/approve-user/${userId}`, {
        status,
        pricePerMinute
    });
    return response.data;
};

export const getFemaleUsers = async () => {
    const response = await api.get('/admin/female-users');
    return response.data;
};

export const updateUserPrice = async (userId, pricePerMinute) => {
    const response = await api.put(`/admin/update-price/${userId}`, {
        pricePerMinute
    });
    return response.data;
};

export const getAllUsers = async () => {
    const response = await api.get('/admin/users');
    return response.data;
};

export const addUserBalance = async (userId, balance) => {
    const response = await api.post(`/admin/add-balance/${userId}`, {
        balance // balance in seconds
    });
    return response.data;
};

export const deleteUser = async (userId) => {
    const response = await api.delete(`/admin/users/${userId}`);
    return response.data;
};

export const resetUserStatus = async (userId) => {
    const response = await api.put(`/auth/reset-status/${userId}`);
    return response.data;
};

export const getPackages = async () => {
    const response = await api.get('/packages');
    return response.data;
};

export const createPackage = async (name, minutes, price) => {
    const response = await api.post('/admin/packages', {
        name,
        minutes,
        price
    });
    return response.data;
};

export const getSettings = async () => {
    const response = await api.get('/admin/settings');
    return response.data;
};

export const updateSettings = async (settings) => {
    const response = await api.put('/admin/settings', settings);
    return response.data;
};

export const getStatistics = async () => {
    const response = await api.get('/admin/statistics');
    return response.data;
};

// TURN server credentials
export const getTurnCredentials = async () => {
    const response = await api.get('/turn-credentials');
    return response.data;
};

export default api;
